/*
 * pachinko-game.js
 * Motore del minigioco "Pachinko fortunato" — tema "Tombini Miti" (ROJI).
 * JS vanilla + <canvas> per piolini/pallina/scia, nessun framework, pensato
 * per un tema Shopify Liquid.
 *
 * Come inserirlo in un tema Shopify:
 * - Copia questo file nella cartella "Assets" del tema
 *   (Admin → Negozio online → Temi → Modifica codice → Assets → Aggiungi asset).
 * - Nella sezione/template che mostra il gioco, includilo con:
 *     {{ 'pachinko-game.js' | asset_url | script_tag }}
 * - Il markup deve contenere un contenitore con classe "pachinko-game"
 *   (vedi pachinko-game.liquid). Lo script si avvia da solo cercando tutti
 *   gli elementi ".pachinko-game" presenti nella pagina.
 *
 * Regola del gioco: si può lanciare quanti tombini si vuole, uno alla
 * volta. Ogni tombino attraversa i piolini, poi entra nel "barattolo"
 * in fondo al tabellone dove continua a essere una vera pallina fisica:
 * cade, tocca il fondo, e se un tombino nuovo lo colpisce si sposta
 * davvero. La prima casella che arriva a WIN_COUNT tombini vince: il
 * premio è quello di quella casella. Il commerciante può personalizzare
 * premi e codici sconto modificando solo le costanti qui sotto.
 */
(function () {
  'use strict';

  // Le 5 caselle premio, nell'ordine mostrato sul tabellone.
  var SLOTS = ['5% off', '10% off', 'Free shipping', '15% off', '5% off'];

  var DISCOUNT_CODES = {
    '5% off': 'LUCKY5',
    '10% off': 'LUCKY10',
    'Free shipping': 'LUCKYSHIP',
    '15% off': 'LUCKY15'
  };

  // Quanti tombini devono fermarsi nella stessa casella perché quella
  // casella vinca. La prima ad arrivarci assegna il premio.
  var WIN_COUNT = 3;

  var ROWS = 8; // righe di piolini
  var COLS = 9; // piolini per riga: stessa quantità su ogni riga, a griglia
  var TRAIL_LENGTH = 10;
  var BALL_RADIUS = 11.7; // raggio base 6.5px, ingrandito del 150% e poi di un ulteriore 20%
  var PEG_RADIUS = 3.4;

  // Parametri della simulazione fisica (vera caduta con gravità e
  // rimbalzi sui piolini, non un percorso disegnato a tavolino).
  var GRAVITY = 2100; // px/s^2 — più deciso, per non restare a lungo tra le file più fitte in fondo
  var RESTITUTION_PEG = 0.4; // "elasticità" del rimbalzo su un piolino
  var RESTITUTION_WALL = 0.6; // elasticità del rimbalzo su pareti del tabellone e piolini
  var RESTITUTION_DIVIDER = 0.2; // i divisori sono "imbottiti": assorbono di più, così i tombini si fermano in fretta nella loro corsia
  var RESTITUTION_BALL = 0.35; // elasticità dell'urto tra due tombini nel "barattolo"
  var SETTLE_MAX_MS = 1800; // tempo massimo lasciato al barattolo per fermarsi del tutto dopo un lancio
  var MAX_SIM_MS = 5000; // sicurezza anti-loop per l'attraversamento dei piolini, non dovrebbe mai servire

  function PachinkoGame(root) {
    this.root = root;
    this.boardEl = root.querySelector('.pachinko-game__board');
    this.canvas = root.querySelector('.pachinko-game__canvas');
    this.ctx = this.canvas.getContext('2d');
    this.slotEls = Array.prototype.slice.call(root.querySelectorAll('.pachinko-game__slot'));
    this.playBtn = root.querySelector('.pachinko-game__play');
    this.messageEl = root.querySelector('.pachinko-game__message-wrap');

    this.pegs = [];
    this.dividers = [];
    this.animating = false;
    this.roundWon = false;
    // Ogni tombino entrato nel "barattolo" in fondo, vero corpo fisico
    // ({x,y,vx,vy}), non un disegno statico: se un tombino nuovo lo
    // colpisce, si muove davvero. Ci restano finché non si ricarica la
    // pagina.
    this.boxBalls = [];
    this.laneCounts = [0, 0, 0, 0, 0];

    // Incrementato a ogni play(): permette a un eventuale ciclo
    // ancora in corso di riconoscere di essere superato e fermarsi da
    // solo, così due lanci non disegnano insieme.
    this._playToken = 0;
    // true dal momento in cui un tombino inizia a cadere fino a quando
    // il barattolo si è di nuovo fermato del tutto: mentre è vero, un
    // ricalcolo del layout (es. da ResizeObserver) NON deve toccare le
    // coordinate, altrimenti tutto si "teletrasporterebbe" da un frame
    // all'altro perché il sistema di riferimento cambia a metà animazione.
    this._ballInFlight = false;

    // Badge con il conteggio (es. "1/3") aggiunto a ogni casella.
    this.slotCountEls = this.slotEls.map(function (el) {
      var badge = document.createElement('span');
      badge.className = 'pachinko-game__slot-count';
      badge.textContent = '0/' + WIN_COUNT;
      el.appendChild(badge);
      return badge;
    });

    var self = this;
    this._onResize = function () {
      // Se un tombino è "in volo" si salta questo ricalcolo (vedi nota
      // su _ballInFlight): verrà comunque rifatto non appena tutto si
      // ferma, quindi non si perde nulla.
      if (self._ballInFlight) return;
      self._layout();
    };

    // Immagine del tombino: uno del set "Miti", passato via attributo
    // data-ball-img (vedi pachinko-game.liquid) così si può sostituire
    // la grafica senza toccare questo file. Se l'immagine non è ancora
    // pronta (o non è impostata), un cerchio dorato la sostituisce,
    // così il gioco resta comunque giocabile.
    this.ballImage = null;
    var ballImgUrl = root.getAttribute('data-ball-img');
    if (ballImgUrl) {
      var img = new Image();
      img.onload = this._onResize; // ridisegna appena l'immagine è pronta
      img.src = ballImgUrl;
      this.ballImage = img;
    }

    // ResizeObserver, oltre a intercettare i normali ridimensionamenti
    // della finestra, si attiva anche quando il pannello passa da
    // "display: none" a visibile (es. cambiando scheda nel selettore
    // dei 3 minigiochi in cima alla pagina): senza questo, i piolini
    // resterebbero calcolati a dimensione zero finché non si preme
    // "TAP TO PLAY" almeno una volta.
    if (typeof ResizeObserver !== 'undefined') {
      this._resizeObserver = new ResizeObserver(this._debounce(this._onResize, 120));
      this._resizeObserver.observe(this.boardEl);
    } else {
      window.addEventListener('resize', this._debounce(this._onResize, 150));
    }

    if (this.playBtn) {
      this.playBtn.addEventListener('click', this.play.bind(this));
    }

    this._layout();
  }

  PachinkoGame.prototype._debounce = function (fn, wait) {
    var t;
    var self = this;
    return function () {
      clearTimeout(t);
      t = setTimeout(function () {
        fn.call(self);
      }, wait);
    };
  };

  PachinkoGame.prototype._layout = function () {
    var rect = this.boardEl.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    this.width = rect.width;
    this.height = rect.height;
    this.canvas.width = Math.round(this.width * dpr);
    this.canvas.height = Math.round(this.height * dpr);
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    this._computePegs();
    this._computeDividers();
    // Mostra il tombino fermo in cima al tabellone, pronto a partire
    // (più quelli già nel barattolo in basso, se ce ne sono), invece
    // di lasciare il tabellone vuoto finché non si preme "TAP TO PLAY".
    this._drawStatic({ x: this.width / 2, y: this.dropY }, []);
  };

  PachinkoGame.prototype._computePegs = function () {
    this.pegs = [];
    var marginTop = this.height * 0.1;
    var marginBottom = this.height * 0.16; // spazio per il "barattolo" in fondo
    var usableHeight = this.height - marginTop - marginBottom;
    // Righe più vicine tra loro del 10% rispetto allo spazio disponibile.
    var rowGap = (usableHeight / (ROWS - 1)) * 0.9;
    // Griglia vera e propria: stesso numero di piolini, alle stesse
    // posizioni orizzontali, su ogni riga (non più una piramide con
    // sempre più piolini scendendo).
    var colSpacing = (this.width * 0.82) / (COLS - 1);
    var rowWidth = (COLS - 1) * colSpacing;
    var startX = this.width / 2 - rowWidth / 2;

    for (var row = 0; row < ROWS; row++) {
      var y = marginTop + row * rowGap;
      // Righe sfalsate: quelle dispari sono spostate di mezza colonna,
      // come in un vero tabellone a "quinconce", così il tombino trova
      // sempre un piolino a incrociare il percorso invece di scendere
      // dritto lungo un corridoio verticale libero.
      var isOffsetRow = row % 2 === 1;
      var offset = isOffsetRow ? colSpacing / 2 : 0;
      var pegsInRow = [];
      if (isOffsetRow) {
        // Pallino aggiuntivo a sinistra: lo spostamento di mezza colonna
        // lascia altrimenti un vuoto sul bordo sinistro di queste righe
        // rispetto a quelle pari.
        pegsInRow.push({ x: startX + offset - colSpacing, y: y });
      }
      for (var c = 0; c < COLS; c++) {
        pegsInRow.push({ x: startX + c * colSpacing + offset, y: y });
      }
      this.pegs.push(pegsInRow);
    }

    this.dropY = marginTop * 0.25;
    this.landY = this.height - marginBottom * 0.5;
    this.lastPegY = this.pegs[ROWS - 1][0].y;
    // Soglia da cui il tombino entra nel "barattolo": un margine oltre
    // l'ultima fila (raggio tombino + raggio piolino) garantisce che il
    // centro del tombino sia già fuori dal raggio di collisione
    // dell'ultima fila prima di iniziare a comportarsi come una
    // pallina libera nel barattolo.
    this.dividerTopY = this.lastPegY + BALL_RADIUS + PEG_RADIUS;
  };

  // Calcola la x di ciascuna linea verticale che, in fondo al
  // tabellone, separa fisicamente le 5 caselle premio: una per ogni
  // spazio tra due caselle consecutive, allineata all'esatto confine
  // mostrato sotto.
  PachinkoGame.prototype._computeDividers = function () {
    var boardRect = this.boardEl.getBoundingClientRect();
    var dividers = [];
    for (var i = 0; i < this.slotEls.length - 1; i++) {
      var r1 = this.slotEls[i].getBoundingClientRect();
      var r2 = this.slotEls[i + 1].getBoundingClientRect();
      dividers.push((r1.right + r2.left) / 2 - boardRect.left);
    }
    this.dividers = dividers;
  };

  // In quale corsia (indice 0-4, stesso ordine di SLOTS) si trova una
  // certa x: usata a fine caduta per leggere in quale casella il
  // tombino è realmente atterrato.
  PachinkoGame.prototype._slotIndexFromX = function (x) {
    for (var i = 0; i < this.dividers.length; i++) {
      if (x < this.dividers[i]) return i;
    }
    return this.dividers.length;
  };

  PachinkoGame.prototype._drawBall = function (x, y) {
    var ctx = this.ctx;
    ctx.save();
    ctx.beginPath();
    ctx.arc(x, y + BALL_RADIUS * 0.35, BALL_RADIUS * 0.9, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(12, 10, 32, 0.35)';
    ctx.fill();
    ctx.restore();

    var imgReady = this.ballImage && this.ballImage.complete && this.ballImage.naturalWidth > 0;
    if (imgReady) {
      ctx.save();
      ctx.beginPath();
      ctx.arc(x, y, BALL_RADIUS, 0, Math.PI * 2);
      ctx.closePath();
      ctx.clip();
      ctx.drawImage(this.ballImage, x - BALL_RADIUS, y - BALL_RADIUS, BALL_RADIUS * 2, BALL_RADIUS * 2);
      ctx.restore();
      ctx.beginPath();
      ctx.arc(x, y, BALL_RADIUS, 0, Math.PI * 2);
      ctx.lineWidth = 1.5;
      ctx.strokeStyle = 'rgba(255, 246, 224, 0.8)';
      ctx.stroke();
    } else {
      ctx.beginPath();
      var grad = ctx.createRadialGradient(x - 2, y - 2, 1, x, y, BALL_RADIUS);
      grad.addColorStop(0, '#fff6e0');
      grad.addColorStop(1, '#d9a441');
      ctx.fillStyle = grad;
      ctx.arc(x, y, BALL_RADIUS, 0, Math.PI * 2);
      ctx.fill();
    }
  };

  PachinkoGame.prototype._drawStatic = function (activeBallPos, trail) {
    var ctx = this.ctx;
    ctx.clearRect(0, 0, this.width, this.height);

    // scia (dietro al tombino che attraversa i piolini)
    if (trail && trail.length) {
      for (var i = 0; i < trail.length; i++) {
        var t = trail[i];
        var alpha = (i + 1) / trail.length;
        ctx.beginPath();
        ctx.fillStyle = 'rgba(246, 227, 176, ' + (alpha * 0.35).toFixed(3) + ')';
        ctx.arc(t.x, t.y, 7.5 * alpha, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // piolini
    ctx.fillStyle = '#d9a441';
    this.pegs.forEach(function (row) {
      row.forEach(function (peg) {
        ctx.beginPath();
        ctx.arc(peg.x, peg.y, PEG_RADIUS, 0, Math.PI * 2);
        ctx.fill();
      });
    });

    // divisori verticali in fondo al tabellone: separano fisicamente le
    // 5 caselle premio, così i tombini restano nel loro scomparto del
    // barattolo.
    if (this.dividers && this.dividers.length) {
      ctx.strokeStyle = 'rgba(217, 164, 65, 0.5)';
      ctx.lineWidth = 2;
      var topY = this.dividerTopY;
      var bottomY = this.height;
      this.dividers.forEach(function (dx) {
        ctx.beginPath();
        ctx.moveTo(dx, topY);
        ctx.lineTo(dx, bottomY);
        ctx.stroke();
      });
    }

    // tombini nel barattolo: veri corpi fisici, alla loro posizione attuale
    var self = this;
    this.boxBalls.forEach(function (b) {
      self._drawBall(b.x, b.y);
    });

    // il tombino che sta ancora attraversando i piolini, oppure quello
    // fermo in cima in attesa del lancio
    if (activeBallPos) {
      this._drawBall(activeBallPos.x, activeBallPos.y);
    }
  };

  PachinkoGame.prototype.play = function () {
    if (this.animating || this.roundWon) return;
    var self = this;

    // Il pannello di questo gioco può essere stato "display: none" (gli
    // altri due minigiochi della pagina, nascosti dal selettore in alto)
    // fino a un attimo fa: ricalcola le misure prima di ogni lancio,
    // altrimenti canvas e piolini resterebbero a dimensione zero.
    this._layout();
    this._playToken++;
    var token = this._playToken;
    this._ballInFlight = true;

    this.animating = true;
    if (this.playBtn) this.playBtn.disabled = true;

    var minX = BALL_RADIUS + 2;
    var maxX = this.width - BALL_RADIUS - 2;

    // Il tombino parte sempre dallo stesso punto, il centro del
    // tabellone: nessuna scelta furba del punto di partenza, solo un
    // minimo di casualità nella spinta iniziale e negli urti coi
    // piolini (vedi collidePegs), così ogni lancio segue un percorso
    // diverso pur partendo sempre da lì.
    var flatPegs = [];
    this.pegs.forEach(function (row) {
      row.forEach(function (peg) {
        flatPegs.push(peg);
      });
    });

    var ball = {
      x: this.width / 2,
      vx: (Math.random() - 0.5) * 40,
      y: this.dropY,
      vy: 0
    };

    var trail = [];
    var lastTs = null;
    var elapsedTotal = 0;

    function collidePegs() {
      for (var i = 0; i < flatPegs.length; i++) {
        var peg = flatPegs[i];
        var dx = ball.x - peg.x;
        var dy = ball.y - peg.y;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var minDist = BALL_RADIUS + PEG_RADIUS;
        if (dist > 0 && dist < minDist) {
          var nx = dx / dist;
          var ny = dy / dist;
          // risolve la compenetrazione: riporta il tombino a toccare il
          // piolino invece di restarci dentro
          var overlap = minDist - dist;
          ball.x += nx * overlap;
          ball.y += ny * overlap;

          var vDotN = ball.vx * nx + ball.vy * ny;
          if (vDotN < 0) {
            ball.vx -= (1 + RESTITUTION_PEG) * vDotN * nx;
            ball.vy -= (1 + RESTITUTION_PEG) * vDotN * ny;
            // piccola componente casuale nell'urto, come un tombino
            // vero: è questa a far sì che due lanci identici non
            // seguano mai esattamente lo stesso percorso.
            ball.vx += (Math.random() - 0.5) * 60;
          }
        }
      }
    }

    // Attraversamento dei piolini: un solo passo fisico di durata
    // subDt, richiamato più volte per fotogramma (vedi runPhysics) con
    // un subDt piccolo, non una volta sola con l'intero dt del
    // fotogramma: a velocità reale il tombino può percorrere anche
    // 40-50px in un fotogramma, più della distanza tra due piolini, e
    // verificare le collisioni una sola volta lo farebbe "attraversare"
    // senza essere rilevato.
    function pegPhaseSubstep(subDt) {
      ball.vy += GRAVITY * subDt;
      ball.x += ball.vx * subDt;
      ball.y += ball.vy * subDt;

      if (ball.x < minX) {
        ball.x = minX;
        ball.vx = Math.abs(ball.vx) * RESTITUTION_WALL;
      } else if (ball.x > maxX) {
        ball.x = maxX;
        ball.vx = -Math.abs(ball.vx) * RESTITUTION_WALL;
      }

      collidePegs();
    }

    function runSubstepped(dt, substepFn) {
      var maxSubDt = 0.003;
      var steps = Math.min(12, Math.max(2, Math.ceil(dt / maxSubDt)));
      var subDt = dt / steps;
      for (var s = 0; s < steps; s++) {
        substepFn(subDt);
      }
    }

    function step(ts) {
      if (token !== self._playToken) return; // un nuovo lancio ha già preso il posto di questo

      if (!lastTs) lastTs = ts;
      var dt = Math.min(0.032, (ts - lastTs) / 1000); // clamp: evita salti se il tab perde il focus
      lastTs = ts;
      elapsedTotal += dt * 1000;

      runSubstepped(dt, pegPhaseSubstep);

      trail.push({ x: ball.x, y: ball.y });
      if (trail.length > TRAIL_LENGTH) trail.shift();
      self._drawStatic({ x: ball.x, y: ball.y }, trail);

      if (ball.y < self.dividerTopY && elapsedTotal < MAX_SIM_MS) {
        requestAnimationFrame(step);
      } else {
        // Il tombino entra nel "barattolo": da qui in poi è un corpo
        // fisico esattamente come tutti gli altri già caduti, con cui
        // può scontrarsi davvero.
        ball.vx *= 0.4; // un urto reale, non un blocco: la velocità laterale residua si smorza solo un poco entrando
        self.boxBalls.push(ball);
        self._runBoxPhase(ball, token);
      }
    }

    requestAnimationFrame(step);
  };

  // Simula l'intero "barattolo" (tutti i tombini già caduti più quello
  // appena entrato) finché non torna fermo, o scade il tempo massimo.
  // Un tombino fermo che viene urtato da uno nuovo si rimette
  // davvero in movimento: non è un disegno statico, è una vera pallina.
  PachinkoGame.prototype._runBoxPhase = function (newBall, token) {
    var self = this;
    var minX = BALL_RADIUS + 2;
    var maxX = this.width - BALL_RADIUS - 2;
    var balls = this.boxBalls;
    var elapsed = 0;
    var lastTs = null;

    function collideDividersFor(b) {
      for (var di = 0; di < self.dividers.length; di++) {
        var dvx = self.dividers[di];
        var ddx = b.x - dvx;
        if (Math.abs(ddx) < BALL_RADIUS) {
          var overlapD = BALL_RADIUS - Math.abs(ddx);
          if (ddx >= 0) {
            b.x += overlapD;
            if (b.vx < 0) b.vx = -b.vx * RESTITUTION_DIVIDER;
          } else {
            b.x -= overlapD;
            if (b.vx > 0) b.vx = -b.vx * RESTITUTION_DIVIDER;
          }
        }
      }
    }

    function collideBallBall(a, b) {
      var dx = b.x - a.x;
      var dy = b.y - a.y;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var minDist = BALL_RADIUS * 2;
      if (dist > 0 && dist < minDist) {
        var nx = dx / dist;
        var ny = dy / dist;
        var overlap = minDist - dist;
        a.x -= (nx * overlap) / 2;
        a.y -= (ny * overlap) / 2;
        b.x += (nx * overlap) / 2;
        b.y += (ny * overlap) / 2;

        var relVx = a.vx - b.vx;
        var relVy = a.vy - b.vy;
        var relDotN = relVx * nx + relVy * ny;
        if (relDotN > 0) {
          // si stanno avvicinando lungo la normale dell'urto: si
          // scambiano quantità di moto come due biglie reali (masse
          // uguali).
          var impulse = (relDotN * (1 + RESTITUTION_BALL)) / 2;
          a.vx -= impulse * nx;
          a.vy -= impulse * ny;
          b.vx += impulse * nx;
          b.vy += impulse * ny;
        }
      }
    }

    function boxSubstep(subDt) {
      for (var i = 0; i < balls.length; i++) {
        var b = balls[i];
        b.vy += GRAVITY * subDt;
        b.x += b.vx * subDt;
        b.y += b.vy * subDt;

        // il fondo del barattolo
        if (b.y > self.landY) {
          b.y = self.landY;
          b.vy = 0;
        }

        // pareti laterali del tabellone
        if (b.x < minX) {
          b.x = minX;
          b.vx = Math.abs(b.vx) * RESTITUTION_WALL;
        } else if (b.x > maxX) {
          b.x = maxX;
          b.vx = -Math.abs(b.vx) * RESTITUTION_WALL;
        }

        collideDividersFor(b);
      }

      for (var p = 0; p < balls.length; p++) {
        for (var q = p + 1; q < balls.length; q++) {
          collideBallBall(balls[p], balls[q]);
        }
      }
    }

    requestAnimationFrame(function loop(ts) {
      if (token !== self._playToken) return;
      if (!lastTs) lastTs = ts;
      var dt = Math.min(0.032, (ts - lastTs) / 1000);
      lastTs = ts;
      elapsed += dt * 1000;

      var maxSubDt = 0.003;
      var steps = Math.min(12, Math.max(2, Math.ceil(dt / maxSubDt)));
      var subDt = dt / steps;
      for (var s = 0; s < steps; s++) boxSubstep(subDt);

      self._drawStatic(null, []);

      var allAtRest = balls.every(function (b) {
        return Math.abs(b.vy) < 40 && Math.abs(b.vx) < 20;
      });

      if (!allAtRest && elapsed < SETTLE_MAX_MS) {
        requestAnimationFrame(loop);
      } else {
        self._onLanded(newBall);
      }
    });
  };

  PachinkoGame.prototype._onLanded = function (ball) {
    this.animating = false;
    this._ballInFlight = false;

    var laneIndex = this._slotIndexFromX(ball.x);
    this.laneCounts[laneIndex]++;
    this.slotCountEls[laneIndex].textContent = this.laneCounts[laneIndex] + '/' + WIN_COUNT;

    if (!this.roundWon && this.laneCounts[laneIndex] >= WIN_COUNT) {
      // Prima casella ad arrivare a WIN_COUNT: vince lei, non importa
      // dove si sia fermato il primo tombino lanciato.
      this.roundWon = true;
      var prize = SLOTS[laneIndex];
      var code = DISCOUNT_CODES[prize] || '';
      this.slotEls[laneIndex].classList.add('is-target');
      this.messageEl.innerHTML =
        '<span class="pachinko-game__message">Hai vinto: ' + prize + '</span>' +
        (code ? '<span class="pachinko-game__code">' + code + '</span>' : '');
      if (this.playBtn) this.playBtn.disabled = true;
    } else if (this.playBtn) {
      this.playBtn.disabled = false;
    }

    // Ridisegna lo stato di riposo: tutti i tombini nel barattolo
    // restano visibili, pronti per il prossimo lancio.
    this._drawStatic({ x: this.width / 2, y: this.dropY }, []);
  };

  function initAll() {
    var roots = document.querySelectorAll('.pachinko-game');
    roots.forEach(function (root) {
      if (root.__pachinkoGame) return;
      root.__pachinkoGame = new PachinkoGame(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
